<template>

  <Fatturazione />

</template>

<script>
import Fatturazione from '../components/fatturazione/Fatturazione.vue'

export default {
  pageName: 'Fatturazione',
  components: {
    Fatturazione

  },
  data() {
    return {

    }
  },

  created(){
    
  },

  mounted(){
    this.$eventBus.emit('page-change', {
      target: this,
      currentRoute: this.$router.currentRoute.value
    })
  },

  methods: {
    
  },
}
</script>
